import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { parseResponse, type InferResponseType } from "hono/client";

import { client } from "~/lib/api";

export type ChildAcquisitionPartner = InferResponseType<
  typeof client.portal.partners.$get,
  200
>[number];
export type PartnerTier = ChildAcquisitionPartner["tier"];

export const childAcquisitionPartnersQueryOptions = () =>
  queryOptions({
    queryKey: ["portal", "partners"] as const,
    queryFn: () => parseResponse(client.portal.partners.$get()),
  });

export const updateChildAcquisitionPartnerTierMutationOptions = () =>
  mutationOptions({
    mutationFn: ({ id, tier }: { id: string; tier: PartnerTier }) =>
      parseResponse(
        client.portal.partners[":id"].$patch({ param: { id }, json: { tier } }),
      ),
    onSuccess: (updated, _variables, _result, context) => {
      context.client.setQueryData(
        childAcquisitionPartnersQueryOptions().queryKey,
        (partners) =>
          partners?.map((partner) => (partner.id === updated.id ? updated : partner)),
      );
    },
  });
